<template>
    <main>
        <Hero title="Customer Case Studies" colour-index="0" sidebar
            subtitle="Our customers save time to build and launch as well as money to build and maintain for integrations."
            left>
        </Hero>

        <div class="page-heading sm:mt-6 sm:mb-6 sm:px-28 ">
            <!-- <small class="text-medium-gray font-semibold uppercase">Recent Customer Case Study</small> -->
            <Article v-if="casestudies?.[0]" :article="casestudies[0] as any" class="w-full lg:w-1/3" include_html />

            <hr class="border-gray-700" />
        </div>

        <div class="page-heading sm:mt-6 sm:pb-6 sm:px-28 gap-y-3 flex flex-wrap">

            <Article class="w-full lg:w-1/3" v-for="article in casestudies?.slice(1)" :key="article.path"
                :article="(article as any)" />
        </div>


    </main>

</template>


<script setup lang="ts">
useHead({
    title: 'Customer Case Studies | Unified.to',
    meta: [{ name: 'description', content: 'Customer Case Studies | Unified.to' }],
});

import { BLOG_CARD_FIELDS } from '~/services/blog';

// Case-study cards only: the result is inlined into the page payload.
const { data } = await useAsyncData('casestudies-cards', () =>
    queryCollection('content')
        .where('path', 'LIKE', '/blog/%')
        .where('tag', 'LIKE', '%Case Studies%')
        .select(...BLOG_CARD_FIELDS)
        .order('date', 'DESC')
        .all()
);

const casestudies = data.value;

</script>